import enUS from "./__translations__/en-US.json";
import nlBE from "./__translations__/nl-BE.json";
import frBE from "./__translations__/fr-BE.json";
import frFR from "./__translations__/fr-FR.json";

export default {
  fr: frBE,
  nl: nlBE,
  "en-US": enUS,
  "nl-BE": nlBE,
  "fr-BE": frBE,
  "fr-FR": frFR,
};
